import { render, staticRenderFns } from "./chatPopUp.vue?vue&type=template&id=633ca4c6&scoped=true"
import script from "./chatPopUp.vue?vue&type=script&lang=js"
export * from "./chatPopUp.vue?vue&type=script&lang=js"
import style0 from "./chatPopUp.vue?vue&type=style&index=0&id=633ca4c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633ca4c6",
  null
  
)

export default component.exports